import { useState } from "react";
import { motion } from "framer-motion";
import { PageShell } from "../components/layout/PageShell";
import { LeadModal } from "../components/shared/LeadCapture";
import { WISDOM_KEEPERS_GALLERY } from "../data/siteContent";

export default function WisdomKeepers() {
  const [open, setOpen] = useState(false);
  return (
    <PageShell>
      <section data-testid="wisdom-keepers-page" className="relative pt-36 md:pt-44 pb-16 overflow-hidden grain">
        <div className="aurora-weave" />
        <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
          <p className="text-sm tracking-[0.24em] uppercase text-[#E7CC86]/80 mb-4">The Company the Work Keeps</p>
          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-cream mb-5">
            A Body of Work Woven with <span className="text-gold">the World's Wisdom Keepers</span>
          </h1>
          <p className="text-lg text-cream/70 max-w-2xl mx-auto">
            Across decades, this work has unfolded in remarkable company—spiritual leaders, visionaries, and changemakers whose paths have intersected with Gary through recording, creative collaboration, and live musical underscoring in service of wisdom, meaning, and our shared humanity.
          </p>
        </div>
      </section>

      <section className="relative py-10 md:py-16 bg-[#0B1020]">
        <div className="max-w-6xl mx-auto px-5 md:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {WISDOM_KEEPERS_GALLERY.map((k, i) => (
              <motion.figure key={k.name}
                data-testid={`wk-tile-${i}`}
                initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="rounded-2xl overflow-hidden ring-1 ring-[#C9A24B]/20 hover:ring-[#C9A24B]/50 transition-all hover:-translate-y-1">
                <img src={k.img} alt={k.name} className="w-full h-auto block" loading="lazy" />
              </motion.figure>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-20 md:py-28 bg-[#080B12] overflow-hidden">
        <div className="aurora-weave slow" />
        <div className="relative z-10 max-w-2xl mx-auto px-5 md:px-8 text-center">
          <h2 className="font-display font-semibold text-3xl md:text-4xl text-cream mb-5">Bring more resonance into your world.</h2>
          <p className="text-lg text-cream/65 mb-8">From personal growth to global gatherings, healthcare to legacy, there are many ways to begin.</p>
          <button data-testid="wk-connect-cta" onClick={() => setOpen(true)} className="btn-gold px-9 py-4 rounded-full text-lg font-semibold">Start a Conversation</button>
        </div>
      </section>

      <LeadModal open={open} onClose={() => setOpen(false)} title="Connect" subtitle="Start a conversation" source="wisdom-keepers" avatar="community" withMessage cta="Send Message" />
    </PageShell>
  );
}
